export default __webpack_public_path__ + "static/media/legs.657711a8.ogg";